/**
 * Map API failures to user-safe strings.
 * Prefer validation field errors; never surface SQL/stack/vendor paths.
 * Backend diagnostics stay in server logs.
 */

const TECHNICAL_RE = /SQLSTATE|SQL\s*syntax|Exception|Stack trace|vendor\\|\\\\[A-Za-z]|Illuminate\\|PDOException|Whoops|at\s+[A-Za-z0-9_\\]+::/i;

function firstValidationMessage(errors) {
  if (!errors || typeof errors !== 'object') return null;
  const first = Object.values(errors).flat().find((v) => typeof v === 'string' && v.trim());
  return first || null;
}

export function isTechnicalApiMessage(message) {
  if (typeof message !== 'string' || !message.trim()) return true;
  return TECHNICAL_RE.test(message);
}

/**
 * @param {unknown} err axios-like error
 * @param {string} fallback already-translated fallback
 * @returns {string}
 */
export function safeApiErrorMessage(err, fallback) {
  const data = err?.response?.data;
  const fromErrors = firstValidationMessage(data?.errors);
  if (fromErrors && !isTechnicalApiMessage(fromErrors)) {
    return fromErrors;
  }
  const msg = data?.message;
  if (typeof msg === 'string' && msg.trim() && !isTechnicalApiMessage(msg)) {
    return msg;
  }
  return fallback;
}
